import React from "react";
import Draggable from "react-draggable";
import { QRCodeCanvas } from "qrcode.react";

export default class CustomQrRedirectDraggable extends React.Component {
  constructor(props) {
    super(props);
    this.nodeRef = React.createRef();
    this.resizeRef = React.createRef();
  }

  state = {
    controlledPosition: {
      x: this.props.textPosition.x,
      y: this.props.textPosition.y,
    },
    infoHidden: false,
    isResizing: false,
    currentSize: this.props.qrSize || 50,
  };

  onControlledDrag = (_, position) => {
    const { x, y } = position;

    this.props.setTextPosition({ x, y });
    this.setState({ controlledPosition: { x, y } });
  };

  handleResizeStart = (e) => {
    e.stopPropagation();
    this.setState({ isResizing: true });

    const startX = e.clientX;
    const startY = e.clientY;
    const startSize = this.state.currentSize;

    const handleMouseMove = (moveEvent) => {
      const deltaX = moveEvent.clientX - startX;
      const deltaY = moveEvent.clientY - startY;
      const delta = Math.max(deltaX, deltaY);

      const newSize = Math.max(45, Math.min(300, startSize + delta));

      this.setState({ currentSize: newSize });

      if (this.props.setQrSize) {
        this.props.setQrSize(newSize);
      }
    };

    const handleMouseUp = () => {
      this.setState({ isResizing: false });
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.textPosition.x !== prevProps.textPosition.x ||
      this.props.textPosition.y !== prevProps.textPosition.y
    ) {
      this.setState({
        controlledPosition: {
          x: this.props.textPosition.x,
          y: this.props.textPosition.y,
        },
        infoHidden: true,
      });
    }

    if (
      this.props.qrSize !== prevProps.qrSize &&
      this.props.qrSize !== this.state.currentSize
    ) {
      this.setState({ currentSize: this.props.qrSize });
    }
  }

  render() {
    const { controlledPosition, infoHidden, currentSize } = this.state;

    return (
      <Draggable
        nodeRef={this.nodeRef}
        axis="both"
        bounds="parent"
        handle=".text-handle"
        scale={1}
        position={controlledPosition}
        onDrag={this.onControlledDrag}
        disabled={this.props.isDetailMode}
      >
        <div className="absolute bottom-0 left-0" ref={this.nodeRef}>
          <div className="relative w-fit">
            {/* QR CODE */}
            <div className="mt-1 flex justify-center w-full bg-white p-[2px]">
              <QRCodeCanvas
                className={`select-none box-border text-gray-700 ${
                  this.props.isDetailMode ? "" : "border border-purple-600"
                }`}
                value="https://verification.peruri.co.id/"
                size={currentSize}
                bgColor="rgba(255,255,255,1)"
                includeMargin={false}
              />
            </div>

            {/* Resize Handle */}
            {!this.props.isDetailMode && (
              <div
                className="absolute bottom-0 right-0 w-4 h-4 bg-purple-600 cursor-se-resize z-10"
                onMouseDown={this.handleResizeStart}
                ref={this.resizeRef}
                style={{
                  borderTopLeftRadius: "2px",
                }}
              >
                <div className="absolute bottom-0 right-0 w-full h-full flex items-end justify-end p-0.5">
                  <div className="w-1.5 h-1.5 border-b-2 border-r-2 border-white"></div>
                </div>
              </div>
            )}

            <div
              className={`absolute flex justify-center items-center w-full h-full top-0 left-0 bg-transparent text-handle cursor-move ${
                this.props.isDetailMode ? "hidden" : ""
              }`}
            >
              <div
                className={`bg-white w-16 text-purple-600 text-xs text-center font-semibold select-none ${
                  infoHidden || this.props.isDetailMode ? "hidden" : ""
                }`}
              >
                Drag
              </div>
            </div>
          </div>
        </div>
      </Draggable>
    );
  }
}
